import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { toEuroString } from '../../../common/utils'
import { MonthlySalesIncentive } from './incentiveProductTypes'

interface Props {
  months: number[]
  lastYearOutcomeData?: MonthlySalesIncentive[]
}

function findMonthsOutcomeData(
  month: number,
  lastYearOutcomeData: MonthlySalesIncentive[] | undefined,
): MonthlySalesIncentive | undefined {
  return lastYearOutcomeData?.find((data) => data.month === month)
}

export default function LastYearOutcomeRow({ months, lastYearOutcomeData }: Props) {
  if (!lastYearOutcomeData) {
    return <></>
  }
  return (
    <TableRow>
      {months.map((month) => (
        <TableCell key={month}>
          {toEuroString(findMonthsOutcomeData(month, lastYearOutcomeData)?.totalIncentiveSales) ?? '-'}
        </TableCell>
      ))}
    </TableRow>
  )
}
